const { getElement, getElements } = window.BAO.Utils

class AnchorsNavigation extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.checkAnchorDestinations()
    this.setupListeners()
  }

  setupListeners () {
    const anchors = getElements('[data-anchor]', { context: this })

    anchors.forEach((anchor) => {
      const anchorId = anchor.getAttribute('href')
      const anchorDestination =
        getElement(anchorId) ||
        getElement(anchorId).closest('.shopify-section')

      anchor.addEventListener('click', (e) => {
        e.preventDefault()
        if (anchorDestination) {
          location.hash = anchorId
          anchorDestination.scrollIntoView({ block: 'center' })
        }
      })
    })
  }

  checkAnchorDestinations () {
    // Remove anchors with no destination
    const initialAnchors = getElements('[data-anchor]', { context: this })
    initialAnchors.forEach((anchor) => {
      const anchorId = anchor.getAttribute('href')
      const anchorDestination = getElement(anchorId)

      if (!anchorDestination) {
        anchor.closest('.sec-PageAnchorsNavigation_Item')?.remove()
      }
    })

    // Check the number of remaining anchors, removing the sction if no anchors remain
    const remainingAnchors = getElements('[data-anchor]', { context: this })
    if (remainingAnchors.length === 0) {
      this.closest('.shopify-section')?.remove()
    }
  }
}

if (!customElements.get('anchors-navigation')) {
  customElements.define('anchors-navigation', AnchorsNavigation)
}
